import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=33e6f1f0&scoped=true"
import script from "./counter.vue?vue&type=script&lang=js"
export * from "./counter.vue?vue&type=script&lang=js"
import style0 from "./counter.vue?vue&type=style&index=0&id=33e6f1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6f1f0",
  null
  
)

export default component.exports